import React from 'react'
import {Link} from "react-router-dom"

function Header() {
  return (
    <div>
     <div className="">
   
    <header className="header_section">
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg custom_nav-container pt-3">
          <Link className="navbar-brand" to="/">
            <img src="images/logo.png" alt="" />
            <span>
              HR Game
            </span>
          </Link>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto mr-2">
              <li className="nav-item active">
                <Link className="nav-link" to="/">Home <span className="sr-only">(current)</span></Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">About </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/portfolio">Portfolio </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/game">Game</Link>
              </li>

              {/* <li className="nav-item">
                <Link className="nav-link" to="/contact.html">Contact us</Link>
              </li> */}
            </ul>
            {/* <div className="user_option">
              <div className="login_btn-container">
                <Link to="/">
                  Login
                </Link>
              </div>
              <form className="form-inline my-2 my-lg-0">
                <button className="btn  my-2 my-sm-0 nav_search-btn" type="submit"></button>
              </form>
            </div> */}
          </div>
          <div className="call_btn">
            <Link to="/">
              Call: + 91 9306421528
            </Link>
          </div>
        </nav>
      </div>
    </header>
  


  </div>
         {/* <div className="custom_menu-container">
    <div className="container">
      <div className="custom_menu">
        <ul className="navbar-nav ">
          <li className="nav-item active">
            <Link className="nav-link pl-0" to="/">Home <span className="sr-only">(current)</span></Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/about">About </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/portfolio">Portfolio </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/game">Game</Link>
          </li>
          
        </ul>
        
      </div>
    </div>
  </div> */}
    </div>
  )
}

export default Header